import { render, staticRenderFns } from "./HeaderNavbarPassport.vue?vue&type=template&id=1325bef5&"
import script from "./HeaderNavbarPassport.vue?vue&type=script&lang=js&"
export * from "./HeaderNavbarPassport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports